import { AlertTypes } from '../plugins/alerts_types'
import { notification } from '../plugins/helpers'

export default {
  mounted () {
    this.getLimiteComprometimentoFaturamento()
  },
  methods: {
    async getLimiteComprometimentoFaturamento () {
      try {
        const result = await this.$http.get(`/parametrizacao/load_parametrizacao/limite_comprometimento_faturamento`)
        if (result.data) {
          this.percentual_minimo_faturamento = result.data.valor
        }
      } catch {
      }
    },
    verificarFaturamentoParaVenda () {
      if (this.pedido && this.pedido.cliente && this.pedido.cliente.pessoa !== undefined && this.pedido.cliente.pessoa !== 'fisica') {
        return this.verificarFaturamento(this.pedido.cliente, this.prazo_parcela_selecionado.valor)
      }
      return true
    },
    verificarFaturamentoParaIniciarVenda (cliente) {
      const valorParcela = this.pedido.politica_vendas ? this.pedido.plano.valor_parcela : this.pedido.vl_parcela

      if (!cliente || !valorParcela) {
        return true
      }

      return this.verificarFaturamento(cliente, valorParcela)
    },
    verificarFaturamento (cliente, valorParcela) {
      if (cliente && this.percentual_minimo_faturamento > 0) {
        const faturamentoInformado = cliente.faturamento_medio || 0
        const valorMinimoFaturamento = (valorParcela * this.percentual_minimo_faturamento) / 100

        if (faturamentoInformado < valorMinimoFaturamento) {
          notification(AlertTypes.WARN, `O valor da parcela selecionada compromete mais que ${this.percentual_minimo_faturamento}% do valor do faturamento.`)
          return false
        }
      }
      return true
    }
  }
}
